import { FormInput } from 'form/FormInput';
import React, { InputHTMLAttributes } from 'react';
import { Label, CheckboxContainer, HiddenCheckbox, StyledCheckbox, Icon } from './Checkbox.styled';

export interface Props extends FormInput, InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  customTitle: JSX.Element | null;
  disabled?: boolean;
  newUi?: boolean;
}

const Checkbox = React.forwardRef<HTMLInputElement, Props>(({ title, customTitle, disabled, ...props }, ref) => (
  <>
    <Label disabled={disabled} newUi={props.newUi}>
      <CheckboxContainer>
        <HiddenCheckbox type="checkbox" ref={ref} {...props} />
        <StyledCheckbox disabled={disabled} newUi={props.newUi}>
          <Icon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 11" newUi={props.newUi}>
            <defs />
            <path d="M4.14 10.36L0 6.22l1.887-1.887 2.253 2.26L10.727 0l1.886 1.887L4.14 10.36z" />
          </Icon>
        </StyledCheckbox>
      </CheckboxContainer>
      {title}
      {customTitle}
    </Label>
  </>
));

export default Checkbox;
